const state = {
  avenant  : { createdAt : { order : 'desc' } },
  client   : { relevance : { order : 'asc' } },
  company  : { createdAt : { order : 'desc' } },
  mandate  : { createdAt : { order : 'desc' } },
  offer    : { createdAt : { order : 'desc' } },
  property : { createdAt : { order : 'desc' } },
  request  : { createdAt : { order : 'desc' } },
  thread   : { createdAt : { order : 'desc' } }
};

const getters = {
  avenantSort  : state => state.avenant,
  clientSort   : state => state.client,
  companySort  : state => state.company,
  mandateSort  : state => state.mandate,
  offerSort    : state => state.offer,
  propertySort : state => state.property,
  requestSort  : state => state.request,
  threadSort   : state => state.thread
};

const mutations = {
  SET_SORT : (state, { model, sort }) => {

    state[model] = sort;
  }
};

const actions = {
  updateElasticSort({ commit }, { model, sort }) {

    commit('SET_SORT', { model, sort });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
